import React from "react";
import axios from "axios";
import { useAuth } from "../../commons/Auth";

export default function useCompaniesWithLogo() {
  const { token }: any = useAuth();
  const [companies, setCompanies] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    async function fetchData() {
      if (!token) return;

      setLoading(true);
      setError(null);

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/hr-companies`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              populate: "logo",
            // "filters[logo][$notNull]" :true , // ✅ solo aziende con logo associato
            },
          }
        );
      const comp = res?.data?.data?.filter((c: any) => c.attributes.logo?.data !== null);
              setCompanies(comp);
            } catch (err: any) {
              setError(err);
            } finally {
              setLoading(false);
            }
          }

    fetchData();
  }, [token]);

  return { companies, loading, error };
}
